module.exports = __webpack_public_path__ + "static/media/oneday_5.1511d981.png";